/**
 *
 * Component: DatePicker
 * Date: 23/10/2020
 *
 */

import React from 'react';

import styles from './style.module.css';

function DatePicker() {
  return <div />;
}

export default DatePicker;
